import { Html, useGLTF } from "@react-three/drei";
import React, { useRef } from "react";
import PlanetText from "../planetText/PlanetText";
import { gsap } from "gsap";
import { useFrame } from "@react-three/fiber";

const MoonModel = (props) => {
    const {
        isSaturnClicked,
        isEarthClicked,
        isJupiterClicked,
        dispatch,
        isUranusClicked,
        isExploreButtonClicked,
        saturnInitialValue,
        jupiterInitialValue,
        earthInitialValue,
    } = props;
    const Moon = useGLTF("./assets/moon.glb");
    const moonModelRef = useRef();
    useFrame((state) => {
        // console.log(state.camera.position);
        // const t1 = gsap.timeline();
        const returnInitialPosition = () => {
            gsap.to(moonModelRef.current.position, {
                x: () => 2.2,
                y: () => -1,
                z: () => 0,
                duration: 2,
            });
            gsap.to(moonModelRef.current.children[0].scale, {
                x: () => 0.0023,
                y: () => 0.0023,
                z: () => 0.0023,
                duration: 2,
            });
        };

        if (
            isSaturnClicked === true &&
            isEarthClicked === false &&
            isJupiterClicked === false &&
            isUranusClicked === false
        ) {
            gsap.to(moonModelRef.current.position, {
                x: () => -2.8,
                y: () => -1.2,
                z: () => 2.2,
                duration: 2,
            });
            gsap.to(moonModelRef.current.children[0].scale, {
                x: () => 0.0015,
                y: () => 0.0015,
                z: () => 0.0015,
                duration: 2,
            });
        }
        if (
            isSaturnClicked === false &&
            saturnInitialValue !== 0 &&
            isEarthClicked === false &&
            isJupiterClicked === false &&
            isUranusClicked === false &&
            isExploreButtonClicked === true
        ) {
            returnInitialPosition();
        }
        if (isEarthClicked === true) {
            gsap.to(moonModelRef.current.position, {
                x: () => -2.8,
                y: () => -1.2,
                z: () => 2.2,
                duration: 2,
            });
            gsap.to(moonModelRef.current.children[0].scale, {
                x: () => 0.0015,
                y: () => 0.0015,
                z: () => 0.0015,
                duration: 2,
            });
        }
        if (
            isEarthClicked === false &&
            earthInitialValue !== 0 &&
            isSaturnClicked === false &&
            isJupiterClicked === false &&
            isUranusClicked === false &&
            isExploreButtonClicked === true
        ) {
            returnInitialPosition();
        }
        if (
            isJupiterClicked === true &&
            isEarthClicked === false &&
            isSaturnClicked === false &&
            isUranusClicked === false &&
            isExploreButtonClicked === true
        ) {
            gsap.to(moonModelRef.current.position, {
                x: () => -2.8,
                y: () => -1.2,
                z: () => 2.2,
                duration: 2,
            });
            gsap.to(moonModelRef.current.children[0].scale, {
                x: () => 0.0015,
                y: () => 0.0015,
                z: () => 0.0015,
                duration: 2,
            });
        }
        if (
            isJupiterClicked === false &&
            isEarthClicked === false &&
            jupiterInitialValue !== 0 &&
            isSaturnClicked === false &&
            isUranusClicked === false &&
            isExploreButtonClicked === true
        ) {
            returnInitialPosition();
        }
        if (
            isUranusClicked === true &&
            isJupiterClicked === false &&
            isEarthClicked === false &&
            isSaturnClicked === false &&
            isExploreButtonClicked === true
        ) {
            gsap.to(moonModelRef.current.position, {
                x: () => -2.8,
                y: () => -1.2,
                z: () => 2.2,
                duration: 2,
            });
            gsap.to(moonModelRef.current.children[0].scale, {
                x: () => 0.0015,
                y: () => 0.0015,
                z: () => 0.0015,
                duration: 2,
            });
        }
    });
    return (
        <group position={[2.2, -1, 0]} ref={moonModelRef}>
            <primitive object={Moon.scene} scale={0.0023} rotation={[2, 1, 0]} />
            <Html position={[0.8, 0.2, 0]}>
                <PlanetText content={""} />
            </Html>
        </group>
    );
};

export default MoonModel;
